import { Inject, Injectable } from '@angular/core';
import { distinctUntilDeepChanged } from '@examdojo/core/rxjs';
import { combineLatest, map, Observable } from 'rxjs';
import { ENTITY_TAG_REPOSITORY, EntityTagRepository } from './entity-tag-repository';
import { TAG_REPOSITORY, TagRepository } from './tag-repository';
import { Tag } from './tag.model';

@Injectable()
export class TagEntityQuery {
  constructor(
    @Inject(TAG_REPOSITORY) private readonly tagRepository: TagRepository,
    @Inject(ENTITY_TAG_REPOSITORY) private readonly entityTagRepository: EntityTagRepository,
  ) {}

  selectTagsForEntity(entityId: string | number): Observable<Tag[]> {
    return combineLatest([this.tagRepository.selectAll(), this.entityTagRepository.selectForEntity(entityId)]).pipe(
      map(([allTags, tagIds]) =>
        tagIds.map((id) => allTags.find((t) => t.id === id)).filter((tag): tag is Tag => !!tag),
      ),
      distinctUntilDeepChanged(),
    );
  }
}
